import { useHistory } from "react-router-dom";

const WCSDecisionMaker = ({ clusters }) => {
  // To access history
  const history = useHistory();

  //based on what data comes back, or not, it routes to the proper component

  if (clusters && clusters.data && clusters.data.clusterIDs === null) {
    history.push("/console/wcs/add-cluster");
    return null;
  } else if (clusters && clusters.data && clusters.data.clusterIDs !== null) {
    history.push("/console/wcs/clusters");
    return null;
  } else {
    return null;
  }
};

export default WCSDecisionMaker;
